import { Button, IconButton, Popover, Text } from '@components'
import { A } from '@solidjs/router'
import { useNotifications } from '@state'
import { Bell } from 'lucide-solid'
import { For, Show, createEffect, createSignal } from 'solid-js'
import { Portal } from 'solid-js/web'
import { useService } from 'solid-services'
import { Circle, Divider, Flex, Grid } from 'styled-system/jsx'
import { useMessageMention } from '../../state/mentions/useMentions'
import NotificationComponent from './Notification'

export default function () {
	const { notifications, setNewNotifications, newNotifications } =
		useService(useNotifications)()
	const { messageMentions } = useService(useMessageMention)()
	const [isOpen, setIsOpen] = createSignal(false)

	const handleClearNotifications = () => {
		// setNotifications([]);
	}

	createEffect(() => {
		console.log(notifications())
	})

	return (
		<Popover.Root
			positioning={{
				placement: 'right-end',
			}}
			closeOnInteractOutside={true}
			open={isOpen()}
			onOpenChange={({ open }) => {
				setNewNotifications(false)
				setIsOpen(open)
			}}
		>
			<Popover.Trigger
				asChild={(triggerProps) => (
					<IconButton
						position="relative"
						{...triggerProps()}
						variant="solid"
						colorPalette={notifications().length ? 'tscGreen' : ''}
					>
						<Bell />
						<Show when={newNotifications()}>
							<Circle
								height="2"
								width="2"
								top={2}
								right={2}
								position="absolute"
								background="red.10"
							/>
						</Show>
					</IconButton>
				)}
			/>
			<Portal>
				<Popover.Positioner>
					<Popover.Content p={0}>
						<Popover.Arrow>
							<Popover.ArrowTip />
						</Popover.Arrow>
						<Grid gap={2}>
							<Show
								when={notifications()?.length}
								fallback={
									<Text
										p={4}
										children="No notficiations"
									/>
								}
							>
								<Grid gap={3}>
									<For each={notifications()}>
										{(notification) => (
											<NotificationComponent
												onAction={() => setIsOpen(false)}
												notification={notification}
											/>
										)}
									</For>
								</Grid>
							</Show>
							<Divider />
							<Flex
								justifyContent="end"
								gap={2}
								pb={2}
								px={2}
							>
								<A href="/updates">
									<Button
										size="xs"
										onClick={() => setIsOpen(false)}
										colorPalette="tscGreen"
										variant="outline"
									>
										View All
									</Button>
								</A>
								{/* <Button
								size="xs"
								colorPalette="tscGreen"
								variant="outline"
							>
								Clear
								<ListX />
							</Button> */}
							</Flex>
						</Grid>
					</Popover.Content>
				</Popover.Positioner>
			</Portal>
		</Popover.Root>
	)
}
